import { useCallback, useEffect, useState } from "react";
import { container } from "tsyringe";
import { useProjectTeamContext } from "components/pages/ProfessionalSpace/contexts/ProjectTeam";
import ProjectTeamCastResponseResource from "common/resources/Project/Config/Team/Cast/ProjectTeamCastResponseResource";
import { useProjectId } from "hooks/useProjectId";
import CastService from "services/projects/CastService";
import CastingCard from "./CastingCard";
import classes from "./classes.module.scss";

const castService = container.resolve(CastService);

export function CastingList() {
	const { casts } = useCasting();

	return (
		<div className={classes["root"]}>
			<div className={classes["casts-container"]}>
				{casts.map((cast) => (
					<CastingCard key={cast.id} cast={cast} />
				))}
			</div>
		</div>
	);
}

const useCasting = () => {
	const { projectId } = useProjectId();
	const { projectTeamId } = useProjectTeamContext();

	const [casts, setCasts] = useState<ProjectTeamCastResponseResource[]>([]);

	const fetchCasts = useCallback(async () => {
		return castService
			.getAllByProjectTeamId(projectId, projectTeamId)
			.then(setCasts)
			.catch((error) => {
				console.error(error);
				setCasts([]);
			});
	}, [projectId, projectTeamId]);

	useEffect(() => {
		fetchCasts();
	}, [fetchCasts]);

	return { casts };
};
